const defaultState = {
  sign_in_details: {
    sign_up: false,
    sign_up_with_email: false
  },
  password_reset_details: {
    email: "",
    code_success: false
  },
  invite_teammate_array: []
};

const signinReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_SIGN_IN_DETAILS": {
      return {
        ...state,
        sign_in_details: action.data
      };
    }
    case "SET_PASSWORD_RESET_DETAILS": {
      return {
        ...state,
        password_reset_details: action.data
      };
    }
    case "SET_INVITE_TEAMMATE_ARRAY": {
      return {
        ...state,
        invite_teammate_array: action.data
      };
    }
    default:
      return state;
  }
};

export default signinReducer;
